jQuery(document).ready(function($) {
  require('./components/parallax-scroll.js');
});


// Popup Message
const popupMessageClose = document.querySelector('.popup-message-close');
const popupMessage = document.querySelector('.popup-message');

window.onload = function () {
  if(popupMessage) {
    if(localStorage.getItem("hasCodeRunBefore") === null) {

      popupMessageClose.addEventListener('click', function() {
        popupMessage.classList.remove('active');
      });

      popupMessage.classList.add('active');

      localStorage.setItem("hasCodeRunBefore", true);
    }
  }
}


// Audio Animation
window.addEventListener("click", () => {
  audioStart();
}, { once: true });

const audioStart = function() {
  const playButtons = document.querySelectorAll('.play-button');

  playButtons.forEach(btn => {

    const mp3SRC = btn.getElementsByClassName('audio')[0].currentSrc;
    const audioBox = btn.previousElementSibling.childNodes[3];
    const audioCanvas = btn.previousElementSibling.childNodes[1];

    var audioPlayer = new Audio();
    audioPlayer.src = mp3SRC;
    audioPlayer.controls = false;
    audioPlayer.loop = false;
    audioPlayer.autoplay = false;

    var canvas, ctx, source, context, analyser, fbc_array, bars, bar_x, bar_width, bar_height;

    initMp3Player();

    function initMp3Player(){
      audioBox.appendChild(audioPlayer);
      context = new AudioContext(); // AudioContext object instance
      analyser = context.createAnalyser(); // AnalyserNode method
      canvas = audioCanvas;
      ctx = canvas.getContext('2d');
      // Re-route audio playback into the processing graph of the AudioContext
      source = context.createMediaElementSource(audioPlayer); 
      source.connect(analyser);
      analyser.connect(context.destination);
      frameLooper();
    }

    function frameLooper(){
      window.requestAnimationFrame(frameLooper);
      fbc_array = new Uint8Array(analyser.frequencyBinCount);
      analyser.getByteFrequencyData(fbc_array);
      ctx.clearRect(0, 0, canvas.width, canvas.height); // Clear the canvas
      ctx.fillStyle = '#70CBD3'; // Color of the bars
      bars = 100;
      for (var i = 0; i < bars; i++) {
        bar_x = i * 3;
        bar_width = 2;
        bar_height = -(fbc_array[i] / 2);
        //  fillRect( x, y, width, height ) // Explanation of the parameters below
        ctx.fillRect(bar_x, canvas.height, bar_width, bar_height);
      }
    }

    audioPlayer.onended = function() {
      btn.classList.toggle('song-active');
    };

    btn.addEventListener('click', function() {
      btn.classList.toggle('song-active');

      if(btn.classList.contains('song-active')) {
        audioPlayer.play();

      } else {
        audioPlayer.pause();
      }
    });
  });
};


// Play + Pause Video
jQuery(document).ready(function($) {
  jQuery('iframe[src*="https://www.youtube.com/embed/"]').addClass("youtube-iframe");
  jQuery('iframe[src*="about:blank"]').addClass("youtube-iframe");

  //Button Hover Load Popup Content
  $(function () {
    $('.parent-button').hover(function() {
      $(this).parent().find('.bio-popup').css("display", "block");
    })
  });

  jQuery('.popup-button').click(function() {
    jQuery(this).next().addClass('active');
    jQuery('body, html').css('overflow-y', 'hidden');
  });

  jQuery('.popup-close').click(function() {
    jQuery(this).closest('.bio-popup').removeClass('active');
    jQuery('body, html').css('overflow-y', 'auto');

    jQuery('.song').removeClass('song-active');

    $('audio').each(function(){
      this.pause();
    });

    jQuery('.youtube-iframe').each(function(index) {
      jQuery(this).attr('src', jQuery(this).attr('src'));
    });
  });

  jQuery('.popup-button-audio').click(function() {
    jQuery(this).closest('.bio-popup-video').removeClass('active');
    jQuery(this).closest('.bio-popup-content').removeClass('active');
    jQuery(this).closest('.buttons-container').children('.bio-popup-audio').addClass('active');

    jQuery('.youtube-iframe').each(function(index) {
      jQuery(this).attr('src', jQuery(this).attr('src'));
    });
  });

  jQuery('.popup-button-content').click(function() {
    jQuery(this).closest('.bio-popup-video').removeClass('active');
    jQuery(this).closest('.bio-popup-audio').removeClass('active');
    jQuery(this).closest('.buttons-container').children('.bio-popup-content').addClass('active');

    jQuery('.song').removeClass('song-active');

    $('audio').each(function(){
      this.pause();
    });

    jQuery('.youtube-iframe').each(function(index) {
      jQuery(this).attr('src', jQuery(this).attr('src'));
    });
  });

  jQuery('.popup-button-video').click(function() {
    jQuery(this).closest('.bio-popup-content').removeClass('active');
    jQuery(this).closest('.bio-popup-audio').removeClass('active');
    jQuery(this).closest('.buttons-container').children('.bio-popup-video').addClass('active');

    jQuery('.song').removeClass('song-active');

    $('audio').each(function(){
      this.pause();
    });
  });
});


// Updated Animation
gsap.registerPlugin(MotionPathPlugin, ScrollTrigger);

const tween = gsap.to("#logo-1", {
  ease: "power1.inOut",
  motionPath: {
    path: "#path-1",
    align: "#path-1",
    autoRotate: false,
    alignOrigin: [0.5, 0.5]
  },
  scrollTrigger: {
    start: 100,
    end: () => "+=" + document.querySelector("#path-1").getBoundingClientRect().height,
    invalidateOnRefresh: true,
    scrub: true,
    onRefresh: self => self.animation.time(Math.max(0.001, self.animation.time()))
  }
});


const tween2 = gsap.to("#logo-2", {
  ease: "power1.inOut",
  motionPath: {
    path: "#path-2",
    align: "#path-2",
    autoRotate: false,
    alignOrigin: [0.5, 0.5]
  },
  scrollTrigger: {
    start: 1200,
    end: () => "+=" + document.querySelector("#path-2").getBoundingClientRect().height,
    invalidateOnRefresh: true,
    scrub: true,
    onRefresh: self => self.animation.time(Math.max(0.001, self.animation.time()))
  }
});


const tween3 = gsap.to("#logo-3", {
  ease: "power1.inOut",
  motionPath: {
    path: "#path-3",
    align: "#path-3",
    autoRotate: false,
    alignOrigin: [0.5, 0.5]
  },
  scrollTrigger: {
    start: 2200,
    end: 5800,
    invalidateOnRefresh: true,
    scrub: true,
    onRefresh: self => self.animation.time(Math.max(0.001, self.animation.time()))
  }
});


const tween4 = gsap.to("#logo-4", {
  ease: "power1.inOut",
  motionPath: {
    path: "#path-4",
    align: "#path-4",
    autoRotate: false,
    alignOrigin: [0.5, 0.5]
  },
  scrollTrigger: {
    start: 6000,
    end: () => "+=" + document.querySelector("#path-4").getBoundingClientRect().height,
    invalidateOnRefresh: true,
    scrub: true,
    onRefresh: self => self.animation.time(Math.max(0.001, self.animation.time()))
  }
});


const mediaQuery2800 = window.matchMedia('(min-height: 2800px)');
const mediaQuery2000 = window.matchMedia('(min-height: 2000px)');

if(mediaQuery2800.matches) {
  const tween5 = gsap.to("#logo-5", {
    ease: "power1.inOut",
    motionPath: {
      path: "#path-5",
      align: "#path-5",
      autoRotate: false,
      alignOrigin: [0.5, 0.5]
    },
    scrollTrigger: {
      start: 6200,
      end: () => "+=" + document.querySelector("#path-5").getBoundingClientRect().height,
      invalidateOnRefresh: true,
      scrub: true,
      onRefresh: self => self.animation.time(Math.max(0.001, self.animation.time()))
    }
  });

} else if(mediaQuery2000.matches) {
  const tween5 = gsap.to("#logo-5", {
    ease: "power1.inOut",
    motionPath: {
      path: "#path-5",
      align: "#path-5",
      autoRotate: false,
      alignOrigin: [0.5, 0.5]
    },
    scrollTrigger: {
      start: 7000,
      end: () => "+=" + document.querySelector("#path-5").getBoundingClientRect().height,
      invalidateOnRefresh: true,
      scrub: true,
      onRefresh: self => self.animation.time(Math.max(0.001, self.animation.time()))
    }
  });

} else {
  const tween5 = gsap.to("#logo-5", {
    ease: "power1.inOut",
    motionPath: {
      path: "#path-5",
      align: "#path-5",
      autoRotate: false,
      alignOrigin: [0.5, 0.5]
    },
    scrollTrigger: {
      start: 7575,
      end: () => "+=" + document.querySelector("#path-5").getBoundingClientRect().height,
      invalidateOnRefresh: true,
      scrub: true,
      onRefresh: self => self.animation.time(Math.max(0.001, self.animation.time()))
    }
  });
}


// Mobile Animation
const desktopMediaQuery = window.matchMedia('(min-width: 450px)');

if(desktopMediaQuery.matches) {
  const mobileTween1 = gsap.to("#mobile-logo-1", {
    ease: "power1.inOut",
    motionPath: {
      path: "#mobile-path-1",
      align: "#mobile-path-1",
      autoRotate: false,
      alignOrigin: [0.5, 0.5]
    },
    scrollTrigger: {
      start: 0,
      end: () => "+=" + document.querySelector("#mobile-path-1").getBoundingClientRect().height,
      invalidateOnRefresh: true,
      scrub: true,
      onRefresh: self => self.animation.time(Math.max(0.001, self.animation.time()))
    }
  });

} else {
  const mobileTween1 = gsap.to("#mobile-logo-1", {
    ease: "power1.inOut",
    motionPath: {
      path: "#mobile-path-1",
      align: "#mobile-path-1",
      autoRotate: false,
      alignOrigin: [0.5, 0.5]
    },
    scrollTrigger: {
      start: 100,
      end: () => "+=" + document.querySelector("#mobile-path-1").getBoundingClientRect().height,
      invalidateOnRefresh: true,
      scrub: true,
      onRefresh: self => self.animation.time(Math.max(0.001, self.animation.time()))
    }
  });
}


if(desktopMediaQuery.matches) {
  const mobileTween2 = gsap.to("#mobile-logo-2", {
    ease: "power1.inOut",
    motionPath: {
      path: "#mobile-path-2",
      align: "#mobile-path-2",
      autoRotate: false,
      alignOrigin: [0.5, 0.5]
    },
    scrollTrigger: {
      start: 1090,
      end: () => "+=" + document.querySelector("#mobile-path-2").getBoundingClientRect().height,
      invalidateOnRefresh: true,
      scrub: true,
      onRefresh: self => self.animation.time(Math.max(0.001, self.animation.time()))
    }
  });

} else {
  const mobileTween2 = gsap.to("#mobile-logo-2", {
    ease: "power1.inOut",
    motionPath: {
      path: "#mobile-path-2",
      align: "#mobile-path-2",
      autoRotate: false,
      alignOrigin: [0.5, 0.5]
    },
    scrollTrigger: {
      start: 1090,
      end: 3000,
      invalidateOnRefresh: true,
      scrub: true,
      onRefresh: self => self.animation.time(Math.max(0.001, self.animation.time()))
    }
  });
}


const mobileTween3 = gsap.to("#mobile-logo-3", {
  ease: "power1.inOut",
  motionPath: {
    path: "#mobile-path-3",
    align: "#mobile-path-3",
    autoRotate: false,
    alignOrigin: [0.5, 0.5]
  },
  scrollTrigger: {
    start: 3160,
    end: () => "+=" + document.querySelector("#mobile-path-3").getBoundingClientRect().height,
    invalidateOnRefresh: true,
    scrub: true,
    onRefresh: self => self.animation.time(Math.max(0.001, self.animation.time()))
  }
});


if(desktopMediaQuery.matches) {
  const mobileTween4 = gsap.to("#mobile-logo-4", {
    ease: "power1.inOut",
    motionPath: {
      path: "#mobile-path-4",
      align: "#mobile-path-4",
      autoRotate: false,
      alignOrigin: [0.5, 0.5]
    },
    scrollTrigger: {
      start: 3700,
      end: 7000,
      invalidateOnRefresh: true,
      scrub: true,
      onRefresh: self => self.animation.time(Math.max(0.001, self.animation.time()))
    }
  });

} else {
  const mobileTween4 = gsap.to("#mobile-logo-4", {
    ease: "power1.inOut",
    motionPath: {
      path: "#mobile-path-4",
      align: "#mobile-path-4",
      autoRotate: false,
      alignOrigin: [0.5, 0.5]
    },
    scrollTrigger: {
      start: 3600,
      end: 6000,
      invalidateOnRefresh: true,
      scrub: true,
      onRefresh: self => self.animation.time(Math.max(0.001, self.animation.time()))
    }
  });
}


if(desktopMediaQuery.matches) {
  const mobileTween5 = gsap.to("#mobile-logo-5", {
    ease: "power1.inOut",
    motionPath: {
      path: "#mobile-path-5",
      align: "#mobile-path-5",
      autoRotate: false,
      alignOrigin: [0.5, 0.5]
    },
    scrollTrigger: {
      start: 6900,
      end: 10500,
      invalidateOnRefresh: true,
      scrub: true,
      onRefresh: self => self.animation.time(Math.max(0.001, self.animation.time()))
    }
  });

} else {
  const mobileTween5 = gsap.to("#mobile-logo-5", {
    ease: "power1.inOut",
    motionPath: {
      path: "#mobile-path-5",
      align: "#mobile-path-5",
      autoRotate: false,
      alignOrigin: [0.5, 0.5]
    },
    scrollTrigger: {
      start: 6000,
      end: 9000,
      invalidateOnRefresh: true,
      scrub: true,
      onRefresh: self => self.animation.time(Math.max(0.001, self.animation.time()))
    }
  });
}